import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        darkTheme: true,
        isLogged: false,
        currentFormPlatform: 'FirstInformationForm1',
        profileId: null,
        statusProfileUserAdm: null,
        isLoading: false,
        showMap: false,
        progress: 0.0,
        showGamificationProgress: false,
        profileAllData: null,
        openProfileComp: false,
        accessTemp: null,
        userReceiveId: null,
        allowRegisterBtn: true,
        allowExportBtn: false,
        mapData: []
    },
    getters: {
        // totalAmountCart(state) {
        //     return state.products
        //         .map(p => p.product.price * p.quantity)
        //         .reduce((total, atual) => total + atual, 0)
        // },
        // getCartProductList(state) {
        //     return state.products
        // }
    },
    mutations: {
        changeTheme(state, status) {
            state.darkTheme = status
        },
        changeIsLogged(state, status) {
            state.isLogged = status
        },
        changeProfileId(state, profileId) {
            state.profileId = profileId
        },
        setIsLoading(state, status) {
            state.isLoading = status
        },
        setShowMap(state, status) {
            state.showMap = status
        },
        setCurrentFormPlatform(state, name) {
            state.currentFormPlatform = name
        },
        setProgress(state, value) {
            state.progress = value
        },
        setStatusProfileUserAdm(state, status) {
            state.statusProfileUserAdm = status
        },
        setProfileAllData(state, data) {
            state.profileAllData = data
        },
        setOpenProfileComp(state, status) {
            state.openProfileComp = status
        },
        setAccessTemp(state, value) {
            state.accessTemp = value
        },
        setUserReceiveId(state, value) {
            state.userReceiveId = value
        },
        setMapData(state, value) {
            state.mapData = value
        },
        setAllowRegisterBtn(state, value) {
            state.allowRegisterBtn = value
        },
        setAllowExportBtn(state, value) {
            state.allowExportBtn = value
        },
        setShowGamificationProgress(state, value) {
            state.showGamificationProgress = value
        }
    },
    actions: {
        changeTheme(context, status) {
            context.commit('changeTheme', status)
        },
        changeIsLogged(context, status) {
            context.commit('changeIsLogged', status)
        },
        changeProfileId(context, data) {
            let profileId = null
            const investidor = 1
            const iniciativa = 2
            const prestador = 3

            if (data.idOrganizacao === 1 && data.prestadorServico === 0) {
                profileId = iniciativa
            } else if (data.idOrganizacao === 1 && data.prestadorServico) {
                profileId = prestador
            } else if (data.idOrganizacao === 2) {
                profileId = investidor
            }
            context.commit('changeProfileId', profileId)
        },
        setIsLoading(context, status) {
            context.commit('setIsLoading', status)
        },
        setShowMap(context, status) {
            context.commit('setShowMap', status)
        },
        setCurrentFormPlatform(context, name) {
            context.commit('setCurrentFormPlatform', name)
        },
        setProgress(context, value) {
            context.commit('setProgress', value)
        },
        setStatusProfileUserAdm(context, status) {
            context.commit('setStatusProfileUserAdm', status)
        },
        setProfileAllData(context, data) {
            context.commit('setProfileAllData', data)
        },
        setOpenProfileComp(context, status) {
            context.commit('setOpenProfileComp', status)
        },
        setAccessTemp(context, value) {
            context.commit('setAccessTemp', value)
        },
        setUserReceiveId(context, value) {
            context.commit('setUserReceiveId', value)
        },
        setMapData(context, value) {
            context.commit('setMapData', value)
        },
        setAllowRegisterBtn(context, value) {
            context.commit('setAllowRegisterBtn', value)
        },
        setAllowExportBtn(context, value) {
            context.commit('setAllowExportBtn', value)
        },
        setShowGamificationProgress(context, value) {
            // console.log('setShowGamificationProgress >>>', value)
            // if (value) {
            //     setTimeout(() => {
            //         console.log('aqui')
            //         context.commit('setShowGamificationProgress', false)
            //     }, 12000)
            // } else {
            //     context.commit('setShowGamificationProgress', value)
            // }
            context.commit('setShowGamificationProgress', value)
        }
        // callAlertSuccess(context, alert) {
        //     let currentAlert = {
        //         message: alert.message,
        //         variantColor: 'success',
        //         showAlert: true
        //     }
        //     context.commit('callAlert', currentAlert)
        //     setTimeout(() => {
        //         currentAlert.showAlert = false
        //         context.commit('callAlert', currentAlert)
        //     }, alert.time)
        // },
        // callAlertError(context, alert) {
        //     let currentAlert = {
        //         message: alert.message,
        //         variantColor: 'danger',
        //         showAlert: true
        //     }
        //     context.commit('callAlert', currentAlert)
        //     setTimeout(() => {
        //         currentAlert.showAlert = false
        //         context.commit('callAlert', currentAlert)
        //     }, alert.time)
        // }
    },
    modules: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js